module.exports = __webpack_public_path__ + "img/jbt7941_2-1995_5.prt.e39c07aa.jpg";